import FeaturePageTemplate from "@/components/FeaturePageTemplate";

export default function AiLccPage() {
  return (
    <FeaturePageTemplate
      slug="lcc"
      accent="#DC2626"
      badge="Core module · Always on"
      title="Lead & Customer Center"
      tagline="One shared customer memory across every channel"
      subtitle="Every form, chat, call, SMS, booking and payment collapses into one permanent record — lead → contact → company → opportunity. AI uses this shared memory to recommend or perform the next permitted action without staff reconstructing history."
      primaryCta={{ label: "Open the Center", to: "/lcc" }}
      secondaryCta={{ label: "See it in action", to: "/audit" }}
      brandStripe="Consent-scoped visibility. Full audit trail. GDPR/CCPA data export & deletion built in."
      flow={[
        { n: "1", title: "Capture",  desc: "Forms, chats, calls, SMS, WhatsApp, bookings — all funnel in." },
        { n: "2", title: "Merge",    desc: "Automatic dedupe on email + phone + external ref." },
        { n: "3", title: "Enrich",   desc: "Every touch enriches the record — no rebuild, no re-ask." },
        { n: "4", title: "Act",      desc: "AI recommends the next best action; humans approve or override." },
        { n: "5", title: "Report",   desc: "One-click exports, weekly digests, revenue timelines." },
      ]}
      capabilities={[
        { icon: "Users",       title: "Unified contact record", desc: "Every channel writes into the same person + company object. No parallel silos." },
        { icon: "GitBranch",   title: "Lead → opportunity",     desc: "Pipeline stages: new · contacted · qualified · proposal · negotiation · won/lost." },
        { icon: "Clock",       title: "Activity timeline",      desc: "Every message, call, form, booking and AI action is time-ordered by contact." },
        { icon: "CheckSquare", title: "Tasks + owners",         desc: "Assignments with due dates. Auto-created from AI recommendations." },
        { icon: "Building2",   title: "Company grouping",       desc: "Roll up multiple contacts into the same company with shared context." },
        { icon: "Download",    title: "CSV / Excel / PDF exports", desc: "Compliant, redacted analysis view + owner-only PII view." },
      ]}
      safetyBullets={[
        ["Consent-scoped visibility", "Only contacts who consented to be contacted show up in outreach exports."],
        ["Duplicate detection",       "Automatic merges on email/phone; manual merge tools for edge cases."],
        ["Right to be forgotten",     "Delete-contact cascade wipes messages, transcripts, and derived analysis."],
        ["Full audit trail",          "Every write is logged with actor, timestamp, and prior value."],
      ]}
      industries={[
        { icon: "UtensilsCrossed", label: "Restaurants",       desc: "Reservations, catering, feedback loops." },
        { icon: "Stethoscope",     label: "Medical & dental",  desc: "Intake, appointments, insurance questions." },
        { icon: "Home",            label: "Real estate",       desc: "Buyer/seller qualification + property match." },
        { icon: "Car",             label: "Auto dealers",      desc: "Vehicle match, financing questions, test drives." },
        { icon: "Wrench",          label: "Contractors",       desc: "Type + urgency + dispatch queue." },
        { icon: "Plane",           label: "Travel",            desc: "Trip inquiry, agent handoff, multi-lingual." },
      ]}
      closingHeadline="Stop losing customers to your own tools."
      closingSubtitle="Every interaction should build on the last. Let AI keep it that way."
      testIdPrefix="ai-lcc-page"
    />
  );
}
